import React, { useLayoutEffect, useRef, useState, } from "react";
import classNames from "classnames";
import ScrollBar from "../ScrollBar";
import * as styles from "./styles.module.scss";
const TextareaScrollbar = ({ textareaRef, onChange, onFocus, onBlur, outlined, className, wrapperClassName, autoHeightMin, autoHeightMax, ...textAreaProps }) => {
    const [currentHeight, setCurrentHeight] = useState(0);
    const [isActive, setIsActive] = useState(false);
    const dummyTextAreaRef = useRef(null);
    const handleChange = (e) => {
        onChange && onChange(e);
        const { current } = dummyTextAreaRef;
        if (current) {
            current.value = e.target.value;
            const targetHeight = current.scrollHeight;
            let height = 0;
            if (e.target && autoHeightMin) {
                height = autoHeightMin > targetHeight ? autoHeightMin : targetHeight;
            }
            setCurrentHeight(height);
        }
    };
    useLayoutEffect(() => {
        const { current } = dummyTextAreaRef;
        if (current) {
            const targetHeight = current.scrollHeight;
            let height = targetHeight;
            if (autoHeightMin) {
                height = autoHeightMin > targetHeight ? autoHeightMin : targetHeight;
            }
            setCurrentHeight(height);
        }
    }, [autoHeightMin, textAreaProps.value]);
    return (React.createElement("div", { className: classNames(styles.wrapper, wrapperClassName, {
            [styles.isActive]: isActive,
            [styles.outlined]: outlined,
        }) },
        React.createElement(ScrollBar, { autoHeight: true, autoHeightMin: autoHeightMin, autoHeightMax: autoHeightMax },
            React.createElement("textarea", { ref: textareaRef, className: classNames(className, styles.textarea), onChange: handleChange, style: { height: currentHeight }, ...textAreaProps, onFocus: (e) => {
                    setIsActive(true);
                    onFocus && onFocus(e);
                }, onBlur: (e) => {
                    setIsActive(false);
                    onBlur && onBlur(e);
                } })),
        React.createElement("div", { className: styles.dummyTextareaWrapper },
            React.createElement("textarea", { onChange: () => null, className: classNames(styles.dummyTextarea, className), ref: dummyTextAreaRef, ...textAreaProps }))));
};
export default TextareaScrollbar;
